<template>
  <f7-page
    @page:beforeout="onPageBeforeRemove"
    @page:afterin="configurarGaleria(0)"
    @infinite="$evento.emit('search:load')"
    :infinite-distance="50"
    :infinite-preloader="false"
    infinite
    :hide-bars-on-scroll="false"
  >
    <f7-navbar back-link="Back">
      <f7-nav-title class="text-madai">
        <f7-link class="no-ripple" @click="activarBusqueda = true">
          Búsqueda
        </f7-link>
      </f7-nav-title>

      <f7-nav-right>
        <f7-link class="text-madai" icon-md="material:search" @click="activarBusqueda = true"></f7-link>
      </f7-nav-right>

      <busqueda
        :activarBusqueda="activarBusqueda"
        :id="'busquedaHome'"
        :catalogo="catalogo"
        :filtros="filtros"
        @searchbar:disable="activarBusqueda = false"
        @search:load-complete="resp => catalogoPaginador = resp"
        @search:data="resp => catalogoFiltrado = resp"
        @search:active="resp => busquedaActiva = resp"
      ></busqueda>
    </f7-navbar>

    <template v-if="activarBusqueda === false || busquedaActiva === false">
      <f7-block>
        <p class="text-center bold fs-30 m-b-10">¿Qué estas buscando?</p>
        <div class="text-center m-b-10">
          <div class="alert alert-secondary bold m-t-0 text-center fs-15" style="display: inline-block;">Haz una búsqueda usando palabras como:</div>
        </div>
        <div class="h-70" style="border: 1px solid #ccc; position: relative">
          <transition name="fade">
            <span class="bold" style="position: relative; left: 65px; z-index: 10; top: 14px;" v-if="verGaleria">
              {{ textoGaleria }}
            </span>
          </transition>
          <div style="position:absolute; top:0px">
            <img class="wd-100" :src="`assets/img/otros/busqueda.png`">
          </div>
        </div>
        <img class="wd-100" src="assets/img/otros/busqueda.jpg" alt="" srcset="">
      </f7-block>
      <f7-block class="wd-100 m-t-0" style="position: absolute; bottom: 0px;">
        <div class="bold text-center fs-12">
          2019 Madai. Todos los derechos reservados.
        </div>
      </f7-block>
    </template>
    <template v-if="busquedaActiva === true">
      <f7-block>
        <f7-row
          v-for="(itms, idx) in partir(catalogoPaginador)"
          :key="idx"
        >
            <f7-col
              v-for="itm in itms"
              :key="itm.c"
            >
              <template v-if="$lodash.isObject(itm)">
              <!-- <f7-card>
                <img class="wd-100" :src="`//madai.mx/assets/images/${itm.i}`" alt="">
              </f7-card> -->
              <f7-card>
                <f7-card-header class="bg-madai hide">
                </f7-card-header>
                <f7-card-content class="p-b-0">
                  <div class="fs-12 text-uppercase bold" style="position: absolute; z-index: 20;">{{ itm.n || itm.c }}</div>
                  <f7-link class="wd-100 no-ripple" :href="obtenerLink(itm.t, itm.id)">
                    <div
                      class="wd-100 h-135"
                      :style="`background-image: url('//madai.mx/assets/images/${itm.i}'); background-position: center; background-repeat: no-repeat; background-size: cover;`" />
                  </f7-link>
                  <img :src="icono(itm.t)" alt="" width="27" style="position: absolute; bottom: 7px; left: 7px; z-index:20;">
                  <div class="hide" style="position:absolute; right:10px; top: 8px;"><img :src="icono(itm.t)" alt="" width="25"></div>
                </f7-card-content>
                <f7-card-footer class="no-border text-center">
                  <f7-row>
                    <div class="fs-14 bold float-right">{{ $helper.str.formatearMoneda(itm.p.toFixed(2)) }} <span class="fs-11 bold m-t-3 m-l-4"> MXN</span> </div>
                  </f7-row>
                </f7-card-footer>
              </f7-card>
              </template>
            </f7-col>
        </f7-row>
      </f7-block>
    </template>
  </f7-page>
</template>

<script>
import busqueda from '@/components/busqueda.vue'
import _ from 'lodash'

export default {
  components: {
    busqueda
  },
  data () {
    return {
      activarBusqueda: false,
      catalogo: [],
      catalogoFiltrado: [],
      catalogoPaginador: [],
      filtros: [],
      textoGaleria: '',
      verGaleria: false,
      busquedaActiva: false
    }
  },
  watch: {
    catalogoPaginador: {
      handler (val) {
        if (val.length % 2 !== 0) {
          this.catalogoPaginador.push('dummy')
        }
      },
      deep: true
    }
  },
  methods: {
    init () {
      if (window.busqueda.length) {
        this.catalogo = window.busqueda
        this.activarBusqueda = true
      } else {
        this.$utils.nextTick(() => {
          this.catalogo = window.busqueda
          this.activarBusqueda = true
        }, 750)
      }
    },
    actualizarElemento (item) {
      this.$set(this.catalogo, this.catalogo.findIndex(itm => itm.cve === item.cve), item)
      this.$set(this.catalogoFiltrado, this.catalogoFiltrado.findIndex(itm => itm.cve === item.cve), item)
      this.$set(this.catalogoPaginador, this.catalogoPaginador.findIndex(itm => itm.cve === item.cve), item)
    },
    configurarGaleria (idx = 0) {
      let galeria = [
        'anillo de compromiso',
        'cadena de oro blanco',
        'aretes 14k',
        'zirconia',
        'pulsera oro amarillo 14k',
        '96610'
      ]
      this.verGaleria = false

      if (idx >= galeria.length) {
        idx = 0
      }

      setTimeout(() => {
        this.textoGaleria = galeria[idx]
        this.verGaleria = true

        setTimeout(() => {
          this.configurarGaleria(idx += 1)
        }, 2500)
      }, 500)

      this.init()
    },
    onPageBeforeRemove () {
      this.activarBusqueda = false
      // eslint-disable-next-line
      var highestTimeoutId = setTimeout(';')
      for (var i = 0; i < highestTimeoutId; i++) {
        clearTimeout(i)
      }
    },
    partir (arr) {
      return _.chunk(arr, 2)
    },
    obtenerLink (id, cve) {
      if (id === 1) { return `/compromiso/${cve}` }
      if (id === 2) { return `/aretes/${cve}` }
      if (id === 3) { return `/zirconia/${cve}` }
      if (id === 4) { return `/argolla/${cve}` }
      if (id === 5) { return `/cadenas/${cve}` }
      if (id === 6) { return `/churumbela/${cve}` }
      if (id === 7) { return `/dijes/${cve}` }
      if (id === 8) { return `/promesa/${cve}` }
      if (id === 9) { return `/pulsera/${cve}` }
      if (id === 10) { return `/conjuntos/${cve}` }
    },
    categoria (id) {
      if (id === 1) { return 'Compromiso' }
      if (id === 2) { return 'Arete' }
      if (id === 3) { return 'Zirconia' }
      if (id === 4) { return 'Argolla' }
      if (id === 5) { return 'Cadena' }
      if (id === 6) { return 'Churumbela' }
      if (id === 7) { return 'Dije' }
      if (id === 8) { return 'Promesa' }
      if (id === 9) { return 'Pulsera' }
      if (id === 10) { return 'Conjuntos' }
    },
    icono (id) {
      if (id === 1) { return 'assets/img/menu/compromiso.svg' }
      if (id === 2) { return 'assets/img/menu/aretes.svg' }
      if (id === 3) { return 'assets/img/menu/zirconia.svg' }
      if (id === 4) { return 'assets/img/menu/argolla.svg' }
      if (id === 5) { return 'assets/img/menu/cadenas.svg' }
      if (id === 6) { return 'assets/img/menu/churumbela.svg' }
      if (id === 7) { return 'assets/img/menu/dijes.svg' }
      if (id === 8) { return 'assets/img/menu/promesa.svg' }
      if (id === 9) { return 'assets/img/menu/pulsera.svg' }
      if (id === 10) { return 'assets/img/menu/conjuntos.svg' }
    }
  },
  mounted () {
    this.$evento.on('update-content', this.actualizarElemento)
  },
  async beforeCreate () {
    window.busqueda = await this.$api.busqueda()
    this.init()
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.text-madai.title {
  margin-left: 0px !important;
}
</style>
